import React from 'react';
import {Link} from 'react-router';
import { ShowIf } from 'components/utils';
import moment from 'moment';
import { connect } from 'react-redux';
import fileDownload from 'js-file-download';
import {checkServerLive} from 'constants/config';
import {downloadFile} from 'components/utils';
import { DuLieuHeThong } from 'api';
import { get } from 'lodash';

class RowItemFileDinhKem extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      type: this.props.type,
      taiLieuVanThuId: this.props.taiLieuVanThuId,
      ten: this.props.ten,
      tenFile: this.props.tenFile,
      ngayQuyetDinh: this.props.ngayQuyetDinh ? new Date(this.props.ngayQuyetDinh) : '',
      soQuyetDinh: this.props.soQuyetDinh,
      progress: 0,
      duongDan: this.props.duongDan,
      isValid: true,
      tinhTrang: this.props.tinhTrang,
      taiLieuBangChungId: this.props.taiLieuBangChungId,

      disableAttachFile: this.props.disableAttachFile,
      dataTinhTrangTaiLieu: this.props.dataTinhTrangTaiLieu,
      nhomHoSoInfo: this.props.nhomHoSoInfo,
    }
  }

  componentDidMount() {
    if(this.props.dataTinhTrangTaiLieu.length == 0) {
      DuLieuHeThong.actions.getTinhTrangTaiLieu.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'tinhTrangTaiLieuList',
            data: res.data || []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.type == 'TAI_LIEU_DINH_KEM') {
      this.setState({
        ten: nextProps.ten,
        tenFile: nextProps.tenFile,
        soQuyetDinh: nextProps.soQuyetDinh,
        taiLieuVanThuId: nextProps.taiLieuVanThuId,
        progress: 0,
        duongDan: nextProps.duongDan,
        disableAttachFile: nextProps.disableAttachFile
      });
    } else {
      this.setState({
        ten: nextProps.ten,
        tenFile: nextProps.tenFile,
        tinhTrang: nextProps.tinhTrang,
        taiLieuVanThuId: nextProps.taiLieuVanThuId,
        duongDan: nextProps.duongDan,
        taiLieuBangChungId: nextProps.taiLieuBangChungId,
        progress: 0,
        disableAttachFile: nextProps.disableAttachFile
      });
    }
    if (nextProps.dataTinhTrangTaiLieu != this.props.dataTinhTrangTaiLieu) {
      this.state.dataTinhTrangTaiLieu = nextProps.dataTinhTrangTaiLieu;
      this.setState({...this.state})
    }
  }

  render() {
    let TinhTrangTaiLieu = this.state.dataTinhTrangTaiLieu.filter(state => {
      return state.giaTri == this.state.tinhTrang
    })

    return (
      <tr className="tr-middle-content attach-file-rows show-items">
        <td style={{width: 45, minWidth: 45, maxWidth: 45}}>{this.props.index + 1}</td>
        <ShowIf condition={this.state.type == 'TAI_LIEU_DINH_KEM'}>
          <td style={{width: 200, minWidth: 200, maxWidth: 200}}>
            <p className="text-13">{this.state.ten}</p>
          </td>
        </ShowIf>
        <ShowIf condition={this.state.type != 'TAI_LIEU_DINH_KEM'}>
          <td style={{width: 165, minWidth: 165, maxWidth: 165}}>
            <p className="text-13">{this.state.ten}</p>
          </td>
        </ShowIf>
        <ShowIf condition={this.state.type != 'TAI_LIEU_DINH_KEM'}>
          <td style={{width: 180, minWidth: 180, maxWidth: 180}}>
            <p className="text-13">{TinhTrangTaiLieu.length > 0 ? TinhTrangTaiLieu[0].ten : ''}</p>
          </td>
        </ShowIf>
        <ShowIf condition={this.state.type == 'TAI_LIEU_DINH_KEM'}>
          <td style={{width: 130, minWidth: 130, maxWidth: 130}}>
            <p className="text-13">{this.state.soQuyetDinh}</p>
          </td>
        </ShowIf>
        <ShowIf condition={this.state.type == 'TAI_LIEU_DINH_KEM'}>
          <td style={{width: 201, minWidth: 201, maxWidth: 201}}>
            <p className="text-13">{this.state.ngayQuyetDinh ? moment(this.state.ngayQuyetDinh).format('DD/MM/YYYY') : ''}</p>
          </td>
        </ShowIf>
        <ShowIf condition={this.state.type == 'TAI_LIEU_DINH_KEM'}>
          <td style={{width: 201, minWidth: 201, maxWidth: 201}}>
            <p className="text-13">{get(this.state, 'nhomHoSoInfo.ten') || ''}</p>
          </td>
        </ShowIf>
        <td className="none-boder">
          <ShowIf condition={!checkServerLive}>
            <Link className="txt-blue txt-underline" onClick={fileDownload.bind(this, this.state.duongDan, this.state.tenFile)}>{this.state.tenFile}</Link>
          </ShowIf>
          <ShowIf condition={checkServerLive}>
            <Link className="txt-blue txt-underline" onClick={()=>{downloadFile(this.state.duongDan, this.state.tenFile)}}>{this.state.tenFile}</Link>
          </ShowIf>
        </td>
        <ShowIf condition={!this.state.disableAttachFile}>
          <td style={{width: 110}}>
          </td>
        </ShowIf>
      </tr>
    );
  }
}

RowItemFileDinhKem.defaultProps = {
  index: null,
  type: 'TAI_LIEU_DINH_KEM',
  dataTinhTrangTaiLieu: [],
  disableAttachFile: false
}

let bindStateToProps = state => {
  return {
    dataTinhTrangTaiLieu: state.duLieuHeThong.tinhTrangTaiLieuList
  }
}

export default connect(bindStateToProps)(RowItemFileDinhKem);



// WEBPACK FOOTER //
// ./src/components/upload/RowItemShowFileDinhKem.jsx